import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Checkbox, InputBase, IconButton } from '@material-ui/core';
import { DeleteIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import lengthVerification from '../../../../utils/lengthVerification';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0 0 0.75rem',
    margin: '0 1.875rem',
  },
  itemBox: {
    marginBottom: '0.75rem',
    fontSize: '1.125rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: theme.palette.font.main,
  },
  inputBox: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    border: '0.0625rem solid #538fff',
    borderRadius: '0.625rem',
    padding: '0 0 0 1.25rem',
  },
  input: {
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  checkBox: {
    '& .MuiSvgIcon-root': {
      height: '2rem',
      width: '2rem',
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.status.green,
      borderRadius: '0.315rem',
    },
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
  },
}));

export default function Checklist({ text, checklistDispatch, index, checklist, deleteId, id }) {
  const classes = useStyles();
  const [value, setValue] = useState(text);

  const handleChange = (event) => {
    if (lengthVerification(event.target.value, 201)) {
      return;
    }
    setValue(event.target.value);
    checklistDispatch({ type: 'change', index: index, text: event.target.value });
  };

  const handleDelete = () => {
    if (checklist.length === 1) {
      setValue('');
      return;
    }
    checklistDispatch({ type: 'remove', index: index });
  };

  return (
    <div className={classes.root}>
      <Box display="flex" className={classes.itemBox}>
        <Checkbox className={classes.checkBox} disabled />
        <Box className={classes.inputBox}>
          <InputBase
            id={id}
            className={classes.input}
            fullWidth
            autoFocus
            placeholder={i18n.t('EHANDOVER_CREATENOTE_CHECKLIST_PLACEHOLDER')}
            value={value}
            onChange={handleChange}
            onKeyDown={(event) => {
              if (event.code === 'Enter' || event.code === 'NumpadEnter') {
                const last = checklist.length - 1;
                checklistDispatch({ type: 'add', item: { id: checklist[last].id + 1, text: '' } });
              }
            }}
          />
          <IconButton
            id={deleteId}
            className={classes.deleteIcon}
            color="primary"
            aria-label="upload picture"
            component="span"
            onClick={handleDelete}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
}
